<!--
  @component
  Font Awesome (free, solid) long-arrow glyphs, inlined so we don't pull in the
  whole Font Awesome dependency for a couple of icons. Inherits color via
  currentColor and scales with the surrounding font-size.

  Usage: <ArrowLong /> (defaults to "right") or <ArrowLong direction="up" />
-->
<script>
  /** @type {{ direction?: "right" | "up" }} */
  let { direction = "right" } = $props();

  // Font Awesome 6 free solid: arrow-right-long / arrow-up-long
  const ICONS = {
    right: {
      viewBox: "0 0 512 512",
      d: "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    },
    up: {
      viewBox: "0 0 384 512",
      d: "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
    }
  };

  let icon = $derived(ICONS[direction] ?? ICONS.right);
</script>

<svg
  class="arrow-long"
  class:up={direction === "up"}
  xmlns="http://www.w3.org/2000/svg"
  viewBox={icon.viewBox}
  aria-hidden="true"
  focusable="false"
>
  <path fill="currentColor" d={icon.d} />
</svg>

<style>
  .arrow-long {
    display: inline-block;
    height: 1.2em;
    width: auto;
    margin-left: 5px;
    vertical-align: middle;
  }
  .arrow-long.up {
    margin-left: 0;
    margin-right: 12px;
  }
</style>
